<template>
  <div>
    <div v-if="isShowTitle" class="drawer-title">
      <div style="display: flex;justify-content:space-between">
        <div class="left">
          <span class="name">流程详情-【{{ formInfo.flowTitle || formInfo.processTitle ||formInfo.processInstanceTitle || '' }}】</span>
          <span v-if="formInfo.approveNo || formInfo.approvalNo" class="right">
            <span class="code">({{ formInfo.approveNo || formInfo.approvalNo }})</span>
          </span>
        </div>
        <span
          :class="`approval-status-now approval-status-now-${formInfo.status}`"
        >{{ formInfo.statusName }}</span>
      </div>
    </div>
    <div v-if="isShowTitle" class="print-divider" />
    <form-parser
      v-if="formConf && show"
      ref="parser"
      :is-text="true"
      :form-conf="formConf"
      :process-id="processId"
    />
  </div>
</template>
<script>
import FormParser from '@/views/form/components/parser'
export default {
  components: {
    FormParser
  },
  props: {
    isShowTitle: {
      type: Boolean,
      default: false
    },
    formConf: {
      type: Object,
      default: () => {
        return null
      }
    },
    formInfo: {
      type: Object,
      default: () => {
        return null
      }
    },
    processId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      show: true
    }
  },
  watch: {
    formConf() {
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    }
  },
  created() {
    console.log(this.formConf, '11111111')
  }
}
</script>
<style lang="scss" scoped>
.drawer-title {
  border-radius: 4px;
  background-color: #fff;
  padding: 16px 20px;
  font-size: 16px;
  font-weight: 500;
  color: #333;
  line-height: 24px;
  .left{
    width:80%;
  }
  .right {
    height: 20px;
    font-size: 14px;
    font-weight: 400;
    color: #999;
    line-height: 20px;
    .code {
      color: #333;
    }
  }
}
.approval-status-now {
  max-height: 28px;
  line-height: 22px;
  padding: 2px 8px;
  border-radius: 2px;
  display: inline-block;
  min-width:80px;
  text-align: center;
  height:28px;
  margin-left: 15px;
  font-size: 14px;
}
.approval-status-now-1 {
  background: #EDF9E8;
  color: #00B42A;
}
.approval-status-now-2 {
  background: #E3E3E3;
  color: #666666;
}
.approval-status-now-3 {
  background: #FFE2E4;
  color: #F54E5A;
}
.approval-status-now-4 {
  background: rgba(0,131,255,0.08);
  color: #0083FF;
}
.approval-status-now-5 {
  background: #E3E3E3;
  color: #666666;
}
.print-divider {
  height: 8px;
  background: #f6f8fc;
}
</style>
